import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

function ActionPillButton({
  label,
  icon,
  onClick,
  title,
  color = "#111827",
  borderColor = "#e8e8f0",
  backgroundColor = "#ffffff",
  variant = "outline", // outline | solid
  size = "sm", // sm | md
  disabled = false,
  style = {},
}) {
  const sizeStyles =
    size === "md"
      ? {
          padding: "8px 14px",
          fontSize: 13,
        }
      : {
          padding: "6px 10px",
          fontSize: 11,
        };

  const finalStyle = {
    borderRadius: 999, // pill real
    border: variant === "outline" ? `1px solid ${borderColor}` : "none",
    background:
      variant === "solid" ? backgroundColor || color : backgroundColor,
    color: variant === "solid" ? "#fff" : color,
    fontWeight: 700,
    cursor: disabled ? "not-allowed" : "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    whiteSpace: "nowrap",
    opacity: disabled ? 0.6 : 1,
    transition: "all 0.2s ease",
    ...sizeStyles,
    ...style,
  };

  return (
    <button
      type="button"
      onClick={!disabled ? onClick : undefined}
      title={title}
      disabled={disabled}
      style={finalStyle}
    >
      {icon && <FontAwesomeIcon icon={icon} />}
      {label}
    </button>
  );
}

export default ActionPillButton;
